export const perplexityDataTypes = {
    perplexity_ai_history: {
        data_type: 'perplexity_ai_history',
        data_type_description: 'Perplexity AI History',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/perlexity/logo.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: false,
        generic: {
        },
        file_source: 'localStorage',
        instructions_type: 'component'
    },
}
